module.exports = __webpack_public_path__ + "media/images/arrow_right_full-ab1c1aeb652d2ee03cdc42931ff735d8.svg";